import { BaseService } from '../../infra/base.service'
import type { MGMemberEntity } from './mgmember.entity'
import type { MGMembersRepository } from './mgmembers.repository'

export class MGMembersService extends BaseService<MGMemberEntity> {
    constructor(private rep: MGMembersRepository) {
        super(rep)
    }
}
